import audioFile from '../assets/audio/notify.wav'
import icon from '../assets/img/BeOn.png'
import {REACT_SOCKET_URL} from '../config.js'
import {messageList} from "../store/actions/messages.js";
import Api from "../Api.js";
let socket = null;
let reconnectTimeout = null;
const playNotificationSound = () => {
    const audio = new Audio(audioFile); // ✅ Path to sound file
    audio.play().catch((error) => console.error("🔇 Error playing sound:", error));
};


export const connectMessageSocket = (token, dispatch,) => {
    const WS_URL = `${REACT_SOCKET_URL}/ws/messages/?token=${token}`;

    socket = new WebSocket(WS_URL);

    socket.onopen = () => {
        console.log("✅ WebSocket message connected");
        // dispatch(taskSocket('on'))

        if (reconnectTimeout) {
            clearTimeout(reconnectTimeout);
            reconnectTimeout = null;
        }
    };

    socket.onmessage = async (event) => {
        const data = JSON.parse(event.data);
        console.log("📩 Received message update:", data);
        const { data: list } = await Api.getRooms()
        dispatch(messageList(list))
        if(data.event !== "seen"){
            playNotificationSound()

        }

    };

    socket.onclose = () => {
        console.warn("⚠️ WebSocket message disconnected, attempting to reconnect...");
        reconnectMessageSocket(token, dispatch);
    };

    socket.onerror = (error) => {
        console.error("❌ WebSocket message error:", error);
        // dispatch(taskSocket('off'))
        socket.close();
    };
};

export const reconnectMessageSocket = (token, dispatch) => {
    if (!reconnectTimeout) {
        reconnectTimeout = setTimeout(() => {
            console.log("♻️ Reconnecting message WebSocket...");
            // dispatch(taskSocket('reconnect'))

            connectMessageSocket(token, dispatch);
        }, 3000);
    }
};

export const disconnectMessageSocket = () => {
    if (socket) {
        socket.close();
    }
};
